import style from './AppLoader.module.scss'
import { AppLoaderProps } from './AppLoader.types'

export default function AppLoader ({ theme }: AppLoaderProps) {
  return (
    <div 
      className={[
        style.app_loader,
        style[theme || 'primary']
      ].join(' ')}
    >
      <div className={style.indicator} />
      <div className={style.indicator} />
      <div className={style.indicator} />
    </div>
  )
}
